.haus-order-confirmation-skeleton {
  width: var(--haus-orderConfirmation__summarySection__width, 100%);
}

.haus-order-confirmation-skeleton__slot {
  display: contents;
}

.haus-order-confirmation-skeleton__list {
  width: 100%;
}

.haus-order-confirmation-skeleton__item {
  border-bottom: var(--haus-orderSummary__block__separator-width, 0.0625rem) solid
    var(--haus-orderSummary__block__separator-color, #e5e5e5);
}

.haus-order-confirmation-skeleton__header {
  padding: var(--haus-orderSummary__header__padding, 1rem);
}

.haus-order-confirmation-skeleton__headerInner {
  display: var(--haus-orderSummary__headerInner__display, flex);
  justify-content: var(--haus-orderSummary__headerInner__justify-content, space-between);
  align-items: var(--haus-orderSummary__headerInner__align-items, flex-start);
  gap: var(--haus-orderSummary__headerInner__gap, 1rem);
  flex-wrap: var(--haus-orderSummary__headerInner__flex-wrap, wrap);
}

.haus-order-confirmation-skeleton__headerInfo {
  display: var(--haus-orderSummary__headerInfo__display, flex);
  gap: var(--haus-orderSummary__headerInfo__gap, 1rem);
  flex-wrap: var(--haus-orderSummary__headerInfo__flex-wrap, wrap);
  min-width: var(--haus-orderSummary__headerInfo__min-width, 0);
  width: var(--haus-orderSummary__headerInfo__width, 100%);
  flex-direction: var(--haus-orderSummary__headerInfo__flex-direction, column);
}

.haus-order-confirmation-skeleton__headerBlock {
  display: var(--haus-orderSummary__headerBlock__display, flex);
  flex-direction: var(--haus-orderSummary__headerBlock__flex-direction, row);
  justify-content: var(--haus-orderSummary__headerBlock__justify-content, space-between);
  align-items: var(--haus-orderSummary__headerBlock__align-items, center);
  gap: var(--haus-orderSummary__headerBlock__gap, 0);
  min-width: var(--haus-orderSummary__headerBlock__min-width, 0);
  width: var(--haus-orderSummary__headerBlock__width, 100%);
}

.haus-order-confirmation-skeleton__headerBlock:nth-child(1) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__orderCode__width, auto);
}

.haus-order-confirmation-skeleton__headerBlock:nth-child(2) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__total__width, auto);
}

.haus-order-confirmation-skeleton__headerBlock:nth-child(3) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__date__width, auto);
}

.haus-order-confirmation-skeleton__headerBlock:nth-child(4) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__state__width, auto);
}

@media only screen and (min-width: 1025px) {
  .haus-order-confirmation-skeleton__headerInfo {
    flex-direction: var(--haus-orderSummary__headerInfo__desktop__flex-direction, row);
    gap: var(--haus-orderSummary__headerInfo__desktop__gap, 2rem);
    width: var(--haus-orderSummary__headerInfo__desktop__width, 100%);
    flex: var(--haus-orderSummary__headerInfo__desktop__flex, 1 1 auto);
    justify-content: var(--haus-orderSummary__headerInfo__desktop__justify-content, space-between);
  }

  .haus-order-confirmation-skeleton__headerBlock {
    flex: 0 0 auto;
    flex-direction: var(--haus-orderSummary__headerBlock__desktop__flex-direction, column);
    justify-content: var(--haus-orderSummary__headerBlock__desktop__justify-content, flex-start);
    align-items: var(--haus-orderSummary__headerBlock__desktop__align-items, flex-start);
    gap: var(--haus-orderSummary__headerBlock__desktop__gap, 0.125rem);
    width: auto;
  }

  .haus-order-confirmation-skeleton__headerBlock:nth-child(1) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__orderCode__width, 12rem);
  }

  .haus-order-confirmation-skeleton__headerBlock:nth-child(2) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__total__width, 8rem);
  }

  .haus-order-confirmation-skeleton__headerBlock:nth-child(3) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__date__width, 8rem);
  }

  .haus-order-confirmation-skeleton__headerBlock:nth-child(4) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__state__width, 8rem);
  }
}

.haus-order-confirmation-skeleton__productSection {
  padding-top: var(--haus-orderSummary__productSection__padding-top, 1rem);
  margin-top: var(--haus-orderSummary__productSection__margin-top, 0);
  border-top: var(--haus-orderSummary__productSection__border-width, 0.0625rem) solid
    var(--haus-orderSummary__productSection__border-color, #e5e5e5);
  width: var(--haus-orderSummary__productSection__width, 100%);
}

.haus-order-confirmation-skeleton__productLineList {
  list-style: var(--haus-orderSummary__productLineList__list-style, none);
  margin: var(--haus-orderSummary__productLineList__margin, 0);
  padding: var(--haus-orderSummary__productLineList__padding, 0);
  display: var(--haus-orderSummary__productLineList__display, flex);
  flex-direction: var(--haus-orderSummary__productLineList__flex-direction, column);
  gap: var(--haus-orderSummary__productLineList__gap, 0);
}

.haus-order-confirmation-skeleton__productLine {
  display: var(--haus-orderSummary__productLine__display, flex);
  align-items: var(--haus-orderSummary__productLine__align-items, flex-end);
  justify-content: var(--haus-orderSummary__productLine__justify-content, space-between);
  gap: var(--haus-orderSummary__productLine__gap, 1rem);
  padding: var(--haus-orderSummary__productLine__padding, 0.75rem);
  border-bottom: var(--haus-orderSummary__productLine__separator-width, 0.0625rem) solid
    var(--haus-orderSummary__productLine__separator-color, #e5e5e5);
}

.haus-order-confirmation-skeleton__productLineLeft {
  display: var(--haus-orderSummary__productLineLeft__display, flex);
  align-items: var(--haus-orderSummary__productLineLeft__align-items, center);
  gap: var(--haus-orderSummary__productLineLeft__gap, 0.75rem);
  min-width: var(--haus-orderSummary__productLineLeft__min-width, 0);
}

.haus-order-confirmation-skeleton__productLineMain {
  display: var(--haus-orderSummary__productLineMain__display, flex);
  flex-direction: var(--haus-orderSummary__productLineMain__flex-direction, column);
  gap: var(--haus-orderSummary__productLineMain__gap, 0.25rem);
  min-width: var(--haus-orderSummary__productLineMain__min-width, 0);
}

.haus-order-confirmation-skeleton__productImage {
  width: var(--haus-orderSummary__productImageWrap__width, 3.75rem);
  height: var(--haus-orderSummary__productImageWrap__height, 3.75rem);
  border-radius: var(--haus-orderSummary__productImageWrap__border-radius, 0.25rem);
  display: block;
}

.haus-order-confirmation-skeleton__lineLabel {
  width: 45%;
  min-height: 14px;
}

.haus-order-confirmation-skeleton__lineValue {
  width: 55%;
  min-height: 16px;
}

.haus-order-confirmation-skeleton__productName {
  width: 180px;
  max-width: 80vw;
  min-height: 16px;
}

.haus-order-confirmation-skeleton__productQuantity {
  width: 72px;
  min-height: 14px;
}

.haus-order-confirmation-skeleton__productPrice {
  width: 64px;
  min-height: 16px;
}

.haus-order-confirmation-skeleton__line,
.haus-order-confirmation-skeleton__productImage {
  background: var(
    --haus-orderConfirmationSkeleton__shimmer__background,
    linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)
  );
  background-size: var(--haus-orderConfirmationSkeleton__shimmer__background-size, 200% 100%);
  animation: haus-order-confirmation-skeleton-shimmer
    var(--haus-orderConfirmationSkeleton__shimmer__animation-duration, 1.5s) infinite ease-in-out;
}

.haus-order-confirmation-skeleton__line {
  display: block;
  border-radius: var(--haus-orderConfirmationSkeleton__line__border-radius, 8px);
}

@keyframes haus-order-confirmation-skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
